import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import TabsComponent from './js/tabs.component';

ComponentsFactory.getInstance().define('tabs', TabsComponent);
